<div class="hvac-login-incentives-item">
    <utc-svg class="hvac-login-incentives-item-icon" [src]="incentive.icon"></utc-svg>
    <div class="hvac-login-incentives-item-content">
        <h3 class="hvac-login-incentives-item-title">{{ incentive.title }}</h3>
        <p class="hvac-login-incentives-item-body">{{ incentive.body }}</p>
    </div>
</div>
